import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LabourChecklistReport } from './Pages/listing';

export const LabourChecklistReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LabourChecklistReport} />
    </Fragment>
)